export default [
  {
    path: '/images/:resourceType/:resourceId',
    name: 'images-gallery',
    component: () => import('@/views/images/ImageGallery.vue'),
    meta: {
      resource: 'images',
      action: 'read',
      breadcrumb: [
        {
          text: 'Images',
          active: true,
        },
      ],
    },
  },
]
